import img1 from "../assets/nebetimg01.png";
import img2 from "../assets/nebetimg02.png";
import img3 from "../assets/nebetimg03.png";
import img4 from "../assets/nebetimg04.png";
import img5 from "../assets/nebetimg05.png";
import img6 from "../assets/nebetimg06.png";
import img7 from "../assets/nebetimg07.png";
import img8 from "../assets/nebetimg01.png";


export const exampleImages = [
  { url: img1 },
  { url: img2 },
  { url: img3 },
  { url: img4 },
  { url: img5 },
  { url: img6 },
  { url: img7 },
  { url: img8 },
];